import SelectBase from '@bugbug/core/components/Select';
import styled from 'styled-components';

export const Select = styled(SelectBase)`
  margin-bottom: 8px;
`;
